export default __webpack_public_path__ + "static/media/issuance-image.1fda9f83.webp";